<template>
  <div>
    <div
      class="flex flex-nowrap justify-between items-center cursor-pointer"
      @click="toggle"
    >
      <span class="text-red font-bold text-2xl">
        {{ formattedIndex }}
      </span>

      <!-- eslint-disable vue/no-v-html -->
      <span
        class="font-bold text-lg px-4 text-left flex-1 lg:text-2xl"
        v-html="question"
      />
      <!-- eslint-enable vue/no-v-html -->

      <div class="w-8 shrink-0">
        <img :src="open ? '/frontend/assets/close-2.svg' : '/frontend/assets/plus.svg'">
      </div>
    </div>

    <!-- eslint-disable vue/no-v-html -->
    <p
      v-show="open"
      class="text-gray-300 mt-4 lg:mt-6 border-b-2 border-b-gray-100 pb-8"
      v-html="answer"
    />
    <!-- eslint-enable vue/no-v-html -->
  </div>
</template>

<script>
export default {
  props: {
    index: {
      type: Number,
      required: true,
    },

    defaultOpen: {
      type: Boolean,
      required: false,
      default: false,
    },

    question: {
      type: String,
      required: true,
    },

    answer: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      open: this.defaultOpen,
    };
  },

  computed: {
    formattedIndex() {
      return this.index.toString().padStart(2, '0');
    },
  },

  methods: {
    toggle() {
      this.open = !this.open;
    },
  },
};
</script>
